import React, { Component, Fragment } from "react";
import { connect, Provider } from "react-redux";
import StyledMapWithAnInfoBox from "../Components/GoogleMap/Map";
import DetailedStyledMapWithAnInfoBox from "../Components/GoogleMap/MapMarker";
import { setGeoLocation } from "../Actions/GoogleMap.action";
import { translate } from "../Services/translation";
class ResellerMapContainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Fragment>
        {this.props.isOpen == false && <StyledMapWithAnInfoBox reseller={this.props} lat={this.props.lat} longt={this.props.longt}></StyledMapWithAnInfoBox>}
        {this.props.isOpen == true && <DetailedStyledMapWithAnInfoBox lat={this.props.lat} longt={this.props.longt} selection={this.props}></DetailedStyledMapWithAnInfoBox>}
        <div className="resellers"><div className="resellers__row">{this.renderReseller()}</div></div>
        <div className="reseller-clear"></div>
      </Fragment>
    );
  }
  onToggleOpen(value) {
    const selectedItemIndex = value.split("_");
    const selectedLocation = this.props.items[selectedItemIndex[0]].items[selectedItemIndex[1]];
    this.props.updateGeoLocation(selectedLocation);
  }
  renderReseller() {
    return this.props.items.map((reseller, index) => (
      <div className="resellers__repeat" key={index}>
        <div className="resellers__address">
          <details>
            <summary className="resellers__title">
              <span className="resellers__title__name">{reseller.Name}</span> <span className="resellers__title__length">{reseller.items.length}</span>
            </summary>
            <code className="details-wrap">
              <div className="reseller-row">
                {reseller.items.map((element, kindex) => (
                  <div className="resellers__details" key={`${index}_${kindex}`}>
                    <h2>{element.AgentName}</h2>
                    <p>{element.Address}</p>
                    <p>
                      <a href={"tel:" + element.Phone}>
                        {translate("resellermap.phone")} : {element.Phone}
                      </a>
                    </p>
                    <p>
                      <a href={"mailto:" + element.Email}>{element.Email}</a>
                    </p>
                    {element.ResellerWebsiteUrl && element.ResellerWebsiteUrl.length >0 && 
                      <p>
                        <a href={element.ResellerWebsiteUrl} target="_blank">{element.ResellerWebsiteUrl}</a>
                      </p>
                    }
                    <p>
                      <span className="show-map" onClick={() => this.onToggleOpen(`${index}_${kindex}`)}>
                        {translate("resellermap.showmap")}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </code>
          </details>
        </div>
      </div>
    ));
  }
}
const mapStateToProps = (state) => {
  const { googlemap } = state;
  return { ...googlemap };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGeoLocation: (value) => {
      dispatch(setGeoLocation(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResellerMapContainer);
